import React from 'react'
import { Box, Stack, Text, Heading } from '@rebeldotcom/components'
import { isInternic } from '@rebeldotcom/ui'
import PropTypes from 'prop-types'

const propTypes = {
  index: PropTypes.number.isRequired,
  optionSelected: PropTypes.number.isRequired,
  setOptionSelected: PropTypes.func.isRequired,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

const ConfiguratorSelect = ({
  optionSelected,
  setOptionSelected,
  index,
  title,
  subtitle,
}) => {
  return (
    <Box onClick={() => setOptionSelected(index)} style={{ cursor: 'pointer' }}>
      <Stack width="100%">
        <Box
          bg={
            // eslint-disable-next-line no-nested-ternary
            optionSelected === index
              ? isInternic
                ? 'grey'
                : 'sunflower'
              : 'transparent'
          }
          borderLeft="1px solid DarkGrey"
          borderRight="1px solid DarkGrey"
          borderTop="1px solid DarkGrey"
          color={
            // eslint-disable-next-line no-nested-ternary
            optionSelected === index
              ? isInternic
                ? 'blueDark'
                : 'deepKoamaru'
              : 'white'
          }
          justifyContent="center"
          width="100%"
        >
          <Text py="1px" textTransform="uppercase" variant="milliBold">
            {title}
          </Text>
        </Box>
        <Box
          bg={optionSelected === index ? 'white' : 'transparent'}
          border="1px solid DarkGrey"
          color={optionSelected === index ? 'black' : 'white'}
          justifyContent="center"
          width="100%"
        >
          <Heading
            my={1}
            pb={4}
            pt={3}
            px={4}
            textAlign="center"
            variant="mega"
            width="80%"
          >
            {subtitle}
          </Heading>
        </Box>
      </Stack>
    </Box>
  )
}

ConfiguratorSelect.propTypes = propTypes
export default ConfiguratorSelect
